import React, { Component } from "react";
import { getQueryParam } from "../../../managers/common/CommonUtil";
import AttendanceImportManager from "./AttendanceImportManager";
import {
  showToast,
  DKButton,
  TOAST_TYPE,
  showLoader,
  DKLabel,
  removeLoader,
} from "deskera-ui-library";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import { convertToCSV, getImportRecords } from "../../import_export/utility/ImportUtility";
import Stepper from "../../common/Stepper";
import { importOptions } from "../../import_export/EximConstants";
import { COUNTRY } from "../../../constants/CountryConstant";
import { DATE_FORMAT } from "../../../constants/Constant";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import ImportService from "../../import_export/service/Import";

class AttendancePortal extends Component {
  constructor(props) {
    super(props);
    this.tableName = getQueryParam(this.props.location, "module");
    this.source = getQueryParam(this.props.location, "origin");
    this.steps = AttendanceImportManager.getAllCreationSteps(this.onSkipToStep);
    this.state = {
      currentStep: 0,
      auditLogId: "",
      fileInfo: null,
      fileContent: null,
      mappedHeaders: null,
      importRecords: null,
      invalidRows: null,
      selectedSegmentId: [],
      importProperties: JSON.parse(importOptions),
    };
  }

  componentDidMount() {
    RouteManager.setPresenter(this);

    /* TableName Query Param is required to proceed */
    if (!this.tableName) {
      RouteManager.navigateToPage(this.source || "/");
    }
  }

  onSkipToStep = (event, index) => {
    const { currentStep } = this.state;

    /* By default expected step is to move forward */
    const expectedStep = index ?? currentStep + 1;

    /* If it's the last step */
    if (expectedStep === this.steps.length) {
      if (this.state.invalidRows && this.state.invalidRows.length) {
        showToast(this.steps[currentStep].reqError, TOAST_TYPE.FAILURE);
      } else {
        this.handleImportConfirmation();
      }
      return;
    }

    if (this.isInvalidStep(expectedStep)) {
      const errorInfo =
        this.steps[currentStep].reqError ||
        `Sorry can't proceed, please complete the current step first`;
      showToast(errorInfo, TOAST_TYPE.FAILURE);
    } else {
      this.setState({ currentStep: expectedStep });
    }
  };

  handleImportConfirmation() {
    let fileName = this.state.fileInfo.name;
    fileName = fileName.replace(/\.[^/.]+$/, "") + ".csv";

    const importRecords = getImportRecords(
      this.state.importRecords,
      this.state.mappedHeaders
    );
    const csvFile = new File([convertToCSV(importRecords)], fileName);

    showLoader("Processing... Please wait");
    AttendanceImportManager.getUploadFileRelativeURL(csvFile).then(
      (filePath) => {
        const payload = {
          dataInsight: {
            dateFormat: this.getDatFormats(),
          },
          mapping: this.state.mapping.map((header) => {
            return {
                colHeader: header.colHeader,
                displayName: header.displayName,
                fieldName: header.fieldName
            }
          })
        };

        const queryParam = {
          module: "PEOPLE_ATTENDANCE",
          relativeFilePath: filePath,
          auditLogId: this.state.auditLogId,
        };
        console.log(payload, queryParam);

        ImportService.import(payload, queryParam).then(
          (response) => {
            removeLoader();
            this.showImportMessage(response);
          },
          (error) => {
            removeLoader();
            showToast(
              "Something went wrong while importing records.",
              TOAST_TYPE.FAILURE
            );
          }
        );
      }
    );
  }

  getDatFormats = () => {
    const country = TenantService.get(TENANT.COUNTRY_CODE);
    switch (country) {
      case COUNTRY.US:
        return "MM/dd/yyyy";
      case COUNTRY.IN:
        return "dd/MM/yyyy";
      default:
        return "dd/MM/yyyy";
    }
  };

  handleStepData = (data, callback) => {
    this.setState({ ...data }, callback);
  };

  isInvalidStep = (expectedStep) => {
    if (expectedStep < 0 || expectedStep >= this.steps.length) return false;

    /* Check if component has required data for expected step */
    const { requiredProps } = this.steps[expectedStep];
    return requiredProps.some(
      (requiredProp) => this.state[requiredProp] === null
    );
  };

  getCurrentStepChild() {
    const currStep = this.steps[this.state.currentStep];
    return currStep.getChild({
      state: this.state,
      tableName: this.tableName,
      setData: this.handleStepData,
    });
  }

  navigateToPage() {
    RouteManager.navigateToPage(PAGE_ROUTES.TEAM_ATTENDANCE);
  }

  getControllers() {
    const { fileInfo, currentStep } = this.state;
    const isLastStep = currentStep === this.steps.length - 1;
    return (
      <div className="row parent-width justify-content-center mb-l">
        {
          <DKButton
            title="Cancel"
            className="border-m ml-r bg-white"
            onClick={(e) => this.navigateToPage()}
          />
        }
        {currentStep !== 0 && (
          <DKButton
            title="Back"
            className="border-m ml-r bg-white"
            onClick={(e) => this.onSkipToStep(e, currentStep - 1)}
          />
        )}
        {fileInfo && (
          <DKButton
            title={!isLastStep ? "Continue" : "Save"}
            className="border-m ml-r bg-app text-white"
            onClick={this.onSkipToStep}
          />
        )}
      </div>
    );
  }

  showImportMessage = (data) => {
    if (
      data["success"] &&
      Array.isArray(data["success"]) &&
      data["success"].length
    ) {
      if (data["invalid_records"].length) {
        showToast(
          `Successful Import: ${data["success"].length}, Rejected Records: ${data["invalid_records"].length}.`,
          TOAST_TYPE.SUCCESS
        );
      } else {
        showToast(
          "Attendance imported successfully.",
          TOAST_TYPE.SUCCESS
        );
      }
    } else if (data["Bulk_Import"]) {
      showToast(
        "Import is in progress, we will notify you once done.",
        TOAST_TYPE.SUCCESS
      );
    } else {
      showToast(
        "Import Unsuccessful, some or all of the records were not imported properly.",
        TOAST_TYPE.FAILURE
      );
    }

    RouteManager.navigateToPage(this.source);
  }

  render() {
    return (
      <>
        <div className="column parent-width">
          <DKLabel text="Import Attendance" className="fw-m fs-l mb-r" />
          <Stepper
            data={this.steps}
            currentIndex={this.state.currentStep}
            className="mb-l"
          />

          <div className="row parent-width m-v-xl justify-content-center">
            {this.getCurrentStepChild()}
          </div>

          {this.getControllers()}
        </div>
      </>
    );
  }
}

export default AttendancePortal;